import React from 'react';
import { EmployeesBioSection } from './employeeBio';
import { StaffingCostsSection } from './staffingCosts';
import { EmployeesActivitySection } from './employeeActivity';
import { SubcontractorsSection } from './subcontractors';
import { ConsumablesSection } from './consumables';
import { CloudComputingsSection } from './cloudComputings';
import { DataLicencesCostsSection } from './dataLicencesCosts';
import { IndependentRndContributionsSection } from './independentRndContributions';
import { SoftwareConsumablesSection } from './ITConsumables';
import { ExternalWorkersSection } from './externalWorkers';
import { TotalCostsSection } from './totalCosts';
import { BenefitCalculationSection } from './benefitCalculation/BenefitCalculationSection';
import { PaymentsToClinicalTrialsSection } from './paymentsToClinicalTrials';
import NotesAndAssumptionsPage from './notesAndAssumptions/NotesAndAssumptionsPage';
export { StaffingCostsRow } from './staffingCosts';
export { Navigation } from './Navigation';
export function urlToSubpage(accountType, pageUrl, claim, refreshClaim, setClaim, debouncedSaveClaim, totalPayrollCostInvalid, saveClaim, project, claimGroup, setClaimGroup, allProjects, projectsLoading) {
  const showCostFragmentsTable = claim.claim_group.staffing_cost_type !== 'rapid';

  // not all props are used in all pages
  const subpageProps = {
    showCostFragmentsTable,
    accountType,
    claim,
    setClaim,
    saveClaim,
    refreshClaim,
    debouncedSaveClaim,
    totalPayrollCostInvalid,
    allProjects,
    projectsLoading
  };
  const urlToSubpageComponent = {
    'employees_bio': () => /*#__PURE__*/React.createElement(EmployeesBioSection, subpageProps),
    'staffing_costs': () => /*#__PURE__*/React.createElement(StaffingCostsSection, subpageProps),
    'notes_and_assumptions': () => /*#__PURE__*/React.createElement(NotesAndAssumptionsPage, subpageProps),
    'employees_activity': () => /*#__PURE__*/React.createElement(EmployeesActivitySection, subpageProps),
    'subcontractors': () => /*#__PURE__*/React.createElement(SubcontractorsSection, subpageProps),
    'external_workers': () => /*#__PURE__*/React.createElement(ExternalWorkersSection, subpageProps),
    'consumables': () => /*#__PURE__*/React.createElement(ConsumablesSection, subpageProps),
    'software': () => /*#__PURE__*/React.createElement(SoftwareConsumablesSection, subpageProps),
    'cloud_computings': () => /*#__PURE__*/React.createElement(CloudComputingsSection, subpageProps),
    'data_licences_costs': () => /*#__PURE__*/React.createElement(DataLicencesCostsSection, subpageProps),
    'independent_rnd_contributions': () => /*#__PURE__*/React.createElement(IndependentRndContributionsSection, subpageProps),
    'payments_to_clinical_trials': () => /*#__PURE__*/React.createElement(PaymentsToClinicalTrialsSection, subpageProps),
    'total_costs': () => /*#__PURE__*/React.createElement(TotalCostsSection, subpageProps),
    'benefit_calculation': () => /*#__PURE__*/React.createElement(BenefitCalculationSection, subpageProps)
  };
  return urlToSubpageComponent[pageUrl]();
}